import React from 'react';
import { Button } from '@mui/material';

const ImageUploadForm = ({ imageUrl, onChangeImage }) => {

  const onImageSelected = _evt => {
    const [file] = document.getElementById('raised-button-file').files;
    if (file) {
      onChangeImage({ blob: file, url: URL.createObjectURL(file) });
    }
  };

  return (
    <>
      <img
        alt="preview"
        src={imageUrl}
        style={{ height: 250, width: '100%', resize: 'cover' }}
      />
      <input
        accept="image/*"
        onChange={onImageSelected}
        style={{ display: 'none' }}
        id="raised-button-file"
        multiple
        type="file"
      />
      <label htmlFor="raised-button-file">
        <Button
          variant="contained"
          component="span"
          color="primary"
          className={'w-full'}>
          Select Image
        </Button>
      </label>
    </>
  );
};

export default ImageUploadForm;
